import { useQuery } from '@tanstack/react-query'
import { httpGetUploaderFolderView } from '@/features/host-review/http/host-review.http'
import { QUERY_KEYS } from '@/query-client'

/**
 * The uploader's folder view. Null means the photoset has no review surface,
 * which the caller renders as today's approved-set page.
 *
 * Archives are built asynchronously after the review closes and the backend
 * announces nothing when they land, so a view read before the build finishes
 * carries no package and the screen says so. It is not polled: the operator
 * reloads, as they do everywhere else in this app.
 */
export const useGetUploaderFolderView = (photosetId?: number) =>
	useQuery({
		queryKey: [QUERY_KEYS.HOST_REVIEW_FOLDERS, photosetId],
		queryFn: () => httpGetUploaderFolderView(Number(photosetId)),
		enabled: Boolean(photosetId),
		retry: false
	})
